import gql from 'graphql-tag'

export const SEARCH_SHARED_TABLE_ORDER_ITEMS_SUPERADMIN = gql`
  query SearchSharedTableOrderItemsSuperadmin($eventId: ID!, $q: String!, $limit: Int) {
    searchSharedTableOrderItemsSuperadmin(eventId: $eventId, q: $q, limit: $limit) {
      id
      eventId
      name
      itemMeta
      sectionSeats
      quantity
      initialQuantity
    }
  }
`

export const CONFIGURE_SHARED_TABLE_SUPERADMIN = gql`
  mutation ConfigureSharedTableSuperadmin($input: ConfigureSharedTableSuperadminInput!) {
    configureSharedTableSuperadmin(input: $input) {
      id
      eventId
      name
      itemMeta
      sectionSeats
      quantity
      initialQuantity
    }
  }
`

export const GET_ADMIN_INVOICE_EXPORT_PREVIEW = gql`
  query GetAdminInvoiceExportPreview($filter: AdminInvoiceExportFilterInput!) {
    getAdminInvoiceExportPreview(filter: $filter) {
      count
      requestedCount
      missingOrderIds
    }
  }
`
